export default {
  years: 'year | years',
  months: 'month | months',
  days: 'day | days',
  hours: 'hour | hours',
  minutes: 'minute | minutes',
  seconds: 'second | seconds'
}
